const s = (e) => {
  if (e && typeof e == "string" && e.includes("px")) {
    const t = parseInt(e, 10);
    if (!Number.isNaN(t))
      return t;
  }
  throw new Error("Invalid breakpoint value");
}, u = (e) => [...e].find(
  (t) => t.nodeType === Node.ELEMENT_NODE && t.nodeName !== "STYLE"
), c = () => {
  const e = (t) => t ? (t ^ Math.random() * 16 >> t / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, e);
  return `uid-${e()}`;
}, d = function(t, n = 100) {
  let r;
  return function(...o) {
    clearTimeout(r), r = setTimeout(() => {
      t.apply(this, o);
    }, n);
  };
}, l = (e, t) => e.composedPath ? e.composedPath().find((n) => n === t) !== void 0 : null, a = (e) => e ? Object.keys(e).length === 0 && e.constructor === Object : !0, m = (e) => {
  const [t, n] = e.split("-");
  return `${t}-${n === "left" ? "start" : "end"}`;
}, f = (e, t) => e.length !== t.length ? !1 : e.every((n, r) => n === t[r]);
export {
  f as arraysEqual,
  d as debounce,
  s as getBreakpointValue,
  u as getFirstElementNodeFromArray,
  m as getFloatingPosition,
  c as getUid,
  a as isEmptyObject,
  l as isEventFiredFromElement
};
